import { Component, OnInit, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { LangService } from 'src/app/services/lang.service';
import { Title } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { Router, NavigationEnd, ActivatedRoute, Data } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { TablerIconsModule } from 'angular-tabler-icons';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-breadcrumb',
    imports: [RouterModule, TablerIconsModule, CommonModule, TranslateModule],
    templateUrl: './breadcrumb.component.html',
    styleUrls: ['./breadcrumb.component.scss'],
})
export class AppBreadcrumbComponent {
  /** La fecha y el título en el idioma de la persona. */
  L = inject(LangService);
  // @Input() layout;
  pageInfo: Data | any = Object.create(null);
  today = new Date();
  myurl: any = this.router.url.slice(1).split('/');
  constructor(
    public router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    
  ) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(
        map((route) => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        })
      )
      .pipe(filter((route) => route.outlet === 'primary'))
      .pipe(mergeMap((route) => route.data))
      // tslint:disable-next-line - Disables all
      .subscribe((event) => {
        // tslint:disable-next-line - Disables all
        this.titleService.setTitle(event['title'] + ' - TTO Logistic');
        this.pageInfo = event;
      });
  }
}
